import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, FeatureFlag, FeatureFlagUpdate, FlagValue } from '@ra-state';
import { deleteFeatureFlag, setFeatureFlags, updateFeatureFlag } from './feature-flags.actions';

@Injectable({
  providedIn: 'root',
})
/* 
  This facade should only be used by harness service to react to harness service events
*/
export class HarnessFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  setFeatureFlags(flags: Record<string, FlagValue>): void {
    this.store$.dispatch(setFeatureFlags({ flags: flags }));
  }

  updateFeatureFlag(update: FeatureFlagUpdate): void {
    this.store$.dispatch(updateFeatureFlag({ payload: update }));
  }

  deleteFeatureFlag(flag: FeatureFlag): void {
    this.store$.dispatch(deleteFeatureFlag({ payload: flag }));
  }
}
